export default "__VITE_ASSET__Becr2pbQ__"